/**
 * Read a named field from an HTML form without FormData.get (Chrome 20+ safe).
 */
export function getFormValue(form: HTMLFormElement, fieldName: string): string {
  if (!form || !fieldName) {
    return "";
  }

  var field = form.elements.namedItem(fieldName);
  if (!field) {
    return "";
  }

  if (typeof (field as HTMLInputElement).value === "string") {
    return (field as HTMLInputElement).value;
  }

  var nodeList = field as RadioNodeList;
  var i: number;
  for (i = 0; i < nodeList.length; i++) {
    var input = nodeList[i] as HTMLInputElement;
    if (input.checked) {
      return input.value || "";
    }
  }

  return "";
}
